import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import tableIcons from "../../components/TableIcon";
import PrintIcon from '@material-ui/icons/Print';
import RefreshIcon from '@material-ui/icons/Refresh';
import hiStore from "../../stores/calHistoryStore";
import Moment from "moment";
import { URL } from "../../constant";

const hisCol = () => [
  {
    title: "월",
    field: "month",
    type: "Number",    
  },
  {
    title: "차수",
    field: "sequence",
    type: "Number",
  },
  {
    title: "이월금액",
    field: "transfer",
    type: "Number",
    render: rowData => {
      return rowData.transfer ? rowData.transfer.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") :  rowData.transfer.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
    },
  },
  {
    title: "시작날짜",
    field: "startDt",
    type: "date",
  },
  {
    title: "종료날짜",
    field: "endDt",
    type: "date",
  },
  {
    title: "첫데이터",
    field: "startId",
    hidden: true,
  },
  {
    title: "끝데이터",
    field: "endId",
    hidden: true,
  },
  {
    title: "이전id",
    field: "prevID",
    hidden: true,
  },
];

function HistoryTable(props) {
  const hisList = props.hisList;

  return(
    <MaterialTable
      title="잡비 정산 기록"
      columns={hisCol()}
      icons={tableIcons}
      data={hisList}    
      options={{
        search: false,
        pageSize: 15,
        pageSizeOptions: [10, 15, 20, 30],
        selection: false,
        showSelectAllCheckbox: false,
        showTextRowsSelected: false,
      }}
      localization={{
        header: { actions: "엑셀"},
      }}
      actions={[
        {
          tooltip: '엑셀로 내보내기',
          icon: PrintIcon,
          position: "row",
          onClick: (evt, rowdata) => {
            let stDt = String(Moment(rowdata.startDt).format('YYMMDD'));
            let edDt = String(Moment(rowdata.endDt).format('YYMMDD'));
            const link = document.createElement("a");
            link.href = URL + "/calculate/excel/?startDte="+rowdata.startDt+"?"+rowdata.endDt+"?"+rowdata.month+"?"+rowdata.sequence+"?"+rowdata.transfer+"?"+stDt+"?"+edDt+"?"+rowdata.startId+"?"+rowdata.endId+"?"+rowdata.prevID;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }  
        },
        {
          tooltip: '새로고침',
          icon: RefreshIcon,
          position: "toolbar",
          onClick: () => {
              hiStore.getList();
          }
        }
      ]}
    />
  );
}

export default HistoryTable;